import { Button, CalculatorIcon, SparkleIcon, Theme } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import React from 'react';

import { createUseStyles } from 'react-jss';
import { applicableBuyerMinimums } from './trucklane-utility';

const styles = {
  overviewLogistics: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      margin: 0,
      fontSize: '16px',
      color: Theme.grey,
      fontWeight: 'normal',
      marginRight: 4,
    },
  },
  noMargin: {
    margin: 0,
  },
};

const useStyles = createUseStyles(styles);

const BuyerMinimumDisplay = ({ buyerMinimums, trucklaneMinimums, aggregateOffer, reservePriceExceptionsEnabled }) => {
  const classes = useStyles();

  const { weightMinimum, palletMinimum } = applicableBuyerMinimums(buyerMinimums, trucklaneMinimums, aggregateOffer?.truckType);
  const minimums = [];
  if (weightMinimum != null) minimums.push(`${accounting.formatNumber(weightMinimum)} lbs`);
  if (palletMinimum != null) minimums.push(`${accounting.formatNumber(palletMinimum)} pallets`);
  if (!minimums.length) return null;
  return (
    <div className={reservePriceExceptionsEnabled ? '' : classes.overviewLogistics}>
      <p className={classes.noMargin}>• Buyer minimums: {minimums.join(' and ')}</p>
    </div>
  );
};

BuyerMinimumDisplay.propTypes = {
  buyerMinimums: PropTypes.object,
  trucklaneMinimums: PropTypes.object,
  aggregateOffer: PropTypes.object,
  reservePriceExceptionsEnabled: PropTypes.bool,
};

export default BuyerMinimumDisplay;
